import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { UserModel } from '@models/user';
import FormDialog from '@components/shared/FormDialog';
import CustomExpansionPanel from '@components/shared/panel/CustomExpansionPanel';

import MagicLinksList from './MagicLinksList';
import MagicLinkForm from './MagicLinkForm';

class MagicLinksContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      magicLinks: props.magicLinks || [],
      isFormDialogOpen: false,
      editingLink: null,
    };
  }

  handleAddNew = () => {
    this.setState({ isFormDialogOpen: true, editingLink: null });
  };

  handleEditLink = (link) => {
    this.setState({ isFormDialogOpen: true, editingLink: link });
  };

  handleCloseDialog = () => {
    this.setState({ isFormDialogOpen: false, editingLink: null });
  };

  handleSuccessCreate = (newLink) => {
    this.setState((prevState) => ({
      magicLinks: [
        newLink,
        ...prevState.magicLinks.filter((link) => link.product_variant_id !== newLink.product_variant_id),
      ],
      isFormDialogOpen: false,
    }));
  };

  handleSuccessUpdate = (updatedLink) => {
    this.setState((prevState) => {
      const magicLinks = prevState.magicLinks.map((link) =>
        link.id === updatedLink.id ? updatedLink : link
      );
      return { magicLinks, isFormDialogOpen: false, editingLink: null };
    });
  };

  handleDelete = (deletedId) => {
    this.setState((prevState) => ({
      magicLinks: prevState.magicLinks.filter((link) => link.id !== deletedId),
    }));
  };

  render() {
    const { user, productVariants } = this.props;
    const { isFormDialogOpen, editingLink, magicLinks } = this.state;
    const isEditing = editingLink !== null;

    return (
      <div className="magic-links-container user-cart-section">
        <CustomExpansionPanel
          id="magic-links-panel"
          headerText="Magic Links"
        >
          <div className="panel__content w-100">
            <div className="d-flex justify-content-end align-items-center p-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={this.handleAddNew}
              >
                New Link
              </button>
            </div>

            <FormDialog
              title={isEditing ? 'Edit Magic Link' : 'New Magic Link'}
              isOpen={isFormDialogOpen}
              onClose={this.handleCloseDialog}
              customClass="dialog__wide"
            >
              <MagicLinkForm
                userId={user.id}
                productVariants={productVariants}
                magicLinks={magicLinks}
                link={editingLink}
                onCancel={this.handleCloseDialog}
                onSuccessCreate={this.handleSuccessCreate}
                onSuccessUpdate={this.handleSuccessUpdate}
              />
            </FormDialog>
          </div>

          <MagicLinksList
            magicLinks={magicLinks}
            userId={user.id}
            onEdit={this.handleEditLink}
            onDelete={this.handleDelete}
            onUpdate={this.handleSuccessUpdate}
          />
        </CustomExpansionPanel>
      </div>
    );
  }
}

MagicLinksContainer.propTypes = {
  user: PropTypes.instanceOf(UserModel).isRequired,
  magicLinks: PropTypes.array,
  productVariants: PropTypes.array,
};

MagicLinksContainer.defaultProps = {
  magicLinks: [],
  productVariants: [],
};

const mapStateToProps = (state) => ({
  user: new UserModel(state.user),
});

export default connect(mapStateToProps)(MagicLinksContainer);
